import React from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App'
import './styles.css'

const qc = new QueryClient({
  defaultOptions: {
    queries: {
      // Operator screens are read constantly; a short stale time keeps them
      // live without hammering the API on every focus change.
      staleTime: 15_000,
      refetchInterval: 30_000,
      retry: (count, err: unknown) => {
        // 401 is handled by the client's refresh path; retrying it would just
        // replay a dead token.
        const status = (err as { status?: number })?.status
        return status !== 401 && status !== 404 && count < 2
      },
    },
  },
})

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={qc}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
)
